import PropTypes from 'prop-types';
import { memo } from 'react';
import { Box } from '@mui/material';
import { StyledRootScrollbar, StyledScrollbar } from './styles';


Scrollbar.propTypes = {
  sx: PropTypes.object,
  children: PropTypes.node,
};

/**
 * Scrollbar is a React component that conditionally renders a custom scrollbar or a native scrollbar based on the device type.
 * 
 * On mobile devices, it uses the native scrollbar by wrapping the children in a Box with overflowX set to 'auto'.
 * On non-mobile devices, it renders a custom scrollbar using StyledRootScrollbar and StyledScrollbar components.
 * 
 * @param {Object} props Component props
 * @param {ReactNode} props.children The content to be wrapped by the scrollbar
 * @param {Object} [props.sx] System style overrides for the component
 * @param {Object} [props.other] Additional props passed to the component
 * @returns {ReactElement} The Scrollbar component
 */

function Scrollbar({ children, sx, ...other }) {
  const userAgent = typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent;

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

  if (isMobile) {
    return (
      <Box sx={{ overflowX: 'auto', ...sx }} {...other}>
        {children}
      </Box>
    );
  }

  return (
    <StyledRootScrollbar>
      <StyledScrollbar timeout={500} clickOnTrack={false} sx={sx} {...other}>
        {children}
      </StyledScrollbar>
    </StyledRootScrollbar>
  );
}

export default memo(Scrollbar);
